export interface CreateKBItemDto {
    natural_language_query: string;
    sql_query: string;
    category?: string;
    answer?: string;
    metadata?: Record<string, any>;
}

export interface UpdateKBItemDto {
    natural_language_query?: string;
    sql_query?: string;
    category?: string;
    answer?: string;
    metadata?: Record<string, any>;
}

export interface RunQueryDto {
    sql: string;
    page?: number;
    page_size?: number;
    search?: string;
    sort_by?: string;
    sort_order?: string;
}
